import Vue from 'vue'
import Router from 'vue-router'
import * as config from '../clientConfiguration'

Vue.use(Router)

import Layout from '../views/layout/Layout'

function notRequireAuth(to, from, next) {
  next()
}

export const constantRouterMap = [

  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/login/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/forgot-password/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/reset-password/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/email-pending',
    name: 'email-pending',
    component: () => import('@/views/email-pending/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/email-confirmation',
    name: 'email-confirmation',
    component: () => import('@/views/email-confirmation/index'),
    beforeEnter: notRequireAuth,
    hidden: true
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/privacy-policy/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    redirect: { name: 'Login' },
    component: () => import('@/views/login/index'),
    hidden: true
  }
]

export default new Router({
  mode: 'history',
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// merchant
export const userRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/mainCertificate/index'),
        meta: {
          title: 'Certificates',
          icon: 'dashboard',
          class: 'material-icons',
          size: '16px',
          special: false,
          sideBarTitle: config.CampusName
        }
      }
    ]
  },
  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    meta: {},
    children: [
      {
        path: '',
        name: 'Change Password',
        component: () => import('@/views/changePassword/index'),
        meta: { title: 'Change Password', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/requests',
    component: Layout,
    hidden: false,
    children: [
      {
        path: '',
        name: 'Request Log',
        component: () => import('@/views/verifyRequest/index'),
        meta: { title: 'Additional Information Request', icon: 'dashboard', class: 'material-icons', size: '16px', sideBarTitle: 'Requests' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

// admin
export const adminRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/mainCertificate/index'),
        meta: {
          title: 'Certificate',
          icon: 'dashboard', class: 'material-icons', size: '16px',
          special: false,
          sideBarTitle: 'Certificate'
        }
      }
    ]
  },
  {
    path: '/institute-management',
    component: Layout,
    meta: {},
    children: [
      {
        path: '',
        name: 'Institutions',
        component: () => import('@/views/adminUserManagement/index'),
        meta: {
          title: 'Institutions',
          icon: 'dashboard', class: 'material-icons', size: '16px',
          sideBarTitle: 'Institutions'
        }
      }
    ]
  },

  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    meta: {},
    children: [
      {
        path: '',
        name: 'Change Password',
        component: () => import('@/views/changePassword/index'),
        meta: { title: 'Change Password', icon: 'form' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js